<template>

<div class="main list-view">

	<div v-if="!showDetail" class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList()" v-focus>
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>
	<div v-else class="sub-header detail-sub-header">
		<div class="detail-title">{{ listDetail.description }}</div>
	</div>

	<div class="filters">

		<label>Restriction List</label>
		<select v-model="filters.exception_list_id" @change="getList()" :disabled="showDetail">
			<option value="">Select...</option>
			<option v-for="list in exceptionLists" :value="list.exception_list_id">{{ list.description }}</option>
		</select>

		<div v-if="!showDetail">
			<div class="divider"></div>
			<ul class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.override ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('override')"></span>
					<label>Has Override</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.custom ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('custom')"></span>
					<label>Is Custom</label>
				</li>
			</ul>
			<div class="divider"></div>
			<div class="button action" @click="addItem()">Add A Product</div>
        </div>

		<div v-if="showDetail">
			<div class="divider"></div>
			<div class="button neutral" @click="backToList(true)">Back To List</div>
        </div>
	</div>

    <div v-if="!showDetail" class="list">
	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>
	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">UPC</th>
					<th class="list">Description</th>
					<th class="list">Department</th>
					<th class="list">Category</th>
					<th class="list center">Override</th>
					<th class="list center">Custom</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in list" class="clickable-list-item" @click="getItem(item)">
					<td class="list">{{ item.upc }}</td>
					<td class="list">{{ item.description }}</td>
					<td class="list">{{ item.department }}</td>
					<td class="list">{{ item.category }}</td>
					<td class="list center"><i v-if="item.exception_list_product_override_id" class="fa fa-check"></i></td>
					<td class="list center"><i v-if="item.client_id" class="fa fa-check"></i></td>
				</tr>
			</tbody>
		</table>
    </div>

    <div v-if="showDetail" class="detail">
		<div class="two-one-columns" style="align-items: start;">
			<div v-if="newProduct">
				<div class="input-with-control">
					<input type="search" ref="product_search_term" v-model="filters.product_search_term" placeholder="Search for a product..." @search="searchProducts()" v-focus>
					<div class="button action input-go" @click="searchProducts()"><i class="fas fa-search"></i></div>
				</div>
				<div class="search-listzzz">
					<div v-if="productList.length == 0" class="empty-list">
						<span v-if="searching">Searching...</span>
						<span v-else>Search list is empty</span>
					</div>

					<table v-else class="data-list" cellpadding="0" cellspacing="0">
						<thead>
							<tr>
								<th class="list" style="width: 3em; padding: 0.25em 0.5em 0.25em 0;"></th>
								<th clsas="list left">Product</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in productList" class="clickable-list-item">
								<td class="list center" style="width: 3em; padding: 0.25em 0.5em 0.25em 0;" @click="saveItem(item)"><img :src="item.image_src"></td>
								<td class="list left" @click="saveItem(item)">{{ item.description }}<div class="meta"><label>ID: </label>{{ item.product_id }} <label>UPC: </label>{{ item.upc }}</div></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div v-else>
				<label>Product</label>
				<input type="text" v-model="listDetail.description" disabled>
				<label>UPC</label>
				<input type="text" v-model="listDetail.upc" disabled>
				<div v-if="listDetail.client_id" style="margin: 1em;">
					This is a custom product restriction.
					<div class="button neutral inline" style="margin: 0 0 0 1em;" @click="confirmOverride('delete','item')">Delete Restriction</div>
				</div>
				<div v-else-if="listDetail.exception_list_product_override_id" style="margin: 1em;">
					You currently have an override for this product restriction by state. 
					<div class="button neutral inline" style="margin: 0 0 0 1em;" @click="confirmOverride('restore','item')">Restore Restriction</div>
				</div>
				<div v-else style="margin: 0.5em 0 1em 0;">
					Distributors have a restriction for this product in this state. 
					<div class="button neutral inline" style="margin: 0 0 0 1em;" @click="confirmOverride('override','item')">Override Restriction</div>
				</div>

				<label>Department</label>
				<input type="text" v-model="listDetail.department" disabled>
				<div class="two-columns" style="margin: 0.5em 0 1em 0;">
					<div>
						<div>Override all restictions for products in {{ listDetail.department }}?</div>
						<div class="button neutral inline" style="margin: 1em 0 0 0;" @click="confirmOverride('override','department')">Override</div>
					</div>
					<div>
						<div>Restore all overrides for products in {{ listDetail.department }}?</div>
						<div class="button neutral inline" style="margin: 1em 0 0 0;" @click="confirmOverride('restore','department')">Restore</div>
					</div>
				</div>
				<label>Category</label>
				<input type="text" v-model="listDetail.category" disabled>
				<div class="two-columns" style="margin: 0.5em 0 1em 0;">
					<div>
						<div>Override all restictions for products in<br>{{ listDetail.department }} {{ listDetail.category }}?</div>
						<div class="button neutral inline" style="margin: 1em 0 0 0;" @click="confirmOverride('override','category')">Override</div>
					</div>
					<div>
						<div>Restore all overrides for products in<br>{{ listDetail.department }} {{ listDetail.category }}?</div>
						<div class="button neutral inline" style="margin: 1em 0 0 0;" @click="confirmOverride('restore','category')">Restore</div>
					</div>
				</div>
			</div>
			<div style="margin: 3em 2em;">
				<p>State restrictions are {{ newProduct ? 'normally' : '' }} set by distributors and affect what can be sold through your website's checkout page.</p>
				<p v-if="newProduct">You can add your own state restrictions as needed.</p>
				<p v-if="!newProduct">If you are confident that you have appropriate state and local licensing, you can override the distributors' restrictions.</p>
				<p v-if="!newProduct">Overriding a restiction does not guarantee that your distributors will ship to you or your customers.</p>
			</div>
		</div>
	</div>

	<div v-if="showConfirmAction" class="modal">
		<div class="inner">
			<h2>{{ listDetail.action }}</h2>
			<div class="content">
				{{ confirmActionLabel }}
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showConfirmAction = false">No</div>
				<div :class="['button', 'spaced', saving ? 'disabled' : 'action']" @click="doException()">Yes, {{ listDetail.action }}</div>
			</div>
		</div>
	</div>

	<iframe id="download" src="" style="display: none;"></iframe>

	<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

</div>

</template>

<script>
export default {
	name: 'state-restrictions',
	data() {
		return {
            loading: false,
			filters: {},
			exceptionLists: [],
			list: [],
			paging: {},
			showDetail: false,
			listDetail: {},
			newProduct: false,
			departments: [],
			categories: [],
            productList: [],
            productPaging: {},
			searching: false,
			gettingExport: false,
			exporting: false,
			exportMessage: '',
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			saving: false,
			confirmActionLabel: '',
			showConfirmAction: false
		}
	},
	created() {
		this.clearFilters()
		this.getExceptionLists()
	},
	computed: {
		exceptionListState() {
			if (this.filters.exception_list_id) {
				for (var index = 0; index < this.exceptionLists.length; index++) {
					if (this.exceptionLists[index].exception_list_id == this.filters.exception_list_id) {
						return this.exceptionLists[index].state
					}
				}
			}
			return ''
		}
	},
	methods: {
		clearFilters() {
			this.filters = {
				page: 1,
				exception_list_id: '',
				search_term: '',
				product_search_term: '',
				override: '',
				custom: '',
				do_export: 0
			}
		},
		getExceptionLists() {
			this.apiCall({ destination: 'get_exception_lists', data: this.filters }).then(obj => {
				this.exceptionLists = obj.exception_lists
				this.filters.exception_list_id = obj.exception_list_id
				this.getList()
			}).catch(err => {
				console.log(err)
			})
		},
		getList() {
			if (this.loading || !this.filters.exception_list_id) { return }
			this.showDetail = false
			this.loading = true
			this.message = 'Loading list...'
			this.apiCall({ destination: 'get_exception_list', data: this.filters }).then(obj => {
				this.loading = false
				this.messageStatus = obj.status
				if (this.filters.do_export) {
					this.filters.do_export = 0
					var outputFile = obj.file_name
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = "//" + document.location.hostname + "/download.php?file_name=" + obj.file_name + "&output_file_name=" + outputFile
						this.gettingExport = false
						this.exportMessage = ''
					}, 1500)
				} else {
					this.list = obj.list
					this.message = obj.message
					if (obj.paging) {
						this.paging = obj.paging
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.filters.page = 1
			this.getList()
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		getItem(item) {
			this.newProduct = false
			this.listDetail = item
			this.showDetail = true
		},
		addItem() {
			this.listDetail = {
				department_id: '',
				category_id: '',
				product_id: ''
			}
			this.newProduct = true
			this.showDetail = true
		},
		confirmOverride(which, level) {
			this.listDetail.action = which
			this.listDetail.level = level
			this.confirmActionLabel = 'Are you sure you want to ' + which
			switch (level) {
				case 'item':
					this.confirmActionLabel += ' the ' + (this.listDetail.client_id ? 'custom' : 'distributor') + ' restriction for item ' + this.listDetail.description
					break;
				case 'category':
					this.confirmActionLabel += ' all distributor restrictions for category ' + this.listDetail.category
					break;
				case 'department':
					this.confirmActionLabel += ' all distributor restrictions for department ' + this.listDetail.department
					break;
			}
			this.confirmActionLabel += ' for the state of ' + this.exceptionListState + '?'
			this.showConfirmAction = true
		},
		doException() {
			if (this.saving) { return }
			this.confirmActionLabel = 'Applying ' + this.listDetail.level + ' ' + this.listDetail.action
			if (this.listDetail.level != 'item') {
				this.confirmActionLabel += ' (this could take a moment)'
			}
			this.saving = true
			this.apiCall({ destination: 'save_exception_override', data: this.listDetail }).then(obj => {
				this.confirmActionLabel = obj.message
				if (obj.status == 'success') {
					setTimeout(() => {
						this.showConfirmAction = false
						this.showDetail = false
						this.listDetail = {}
						this.getList()
						this.saving = false
					}, 1500)
				} else {
					this.saving = false
				}
			}).catch(err => {
				console.log(err)
			})

		},
		searchProducts() {
			if (this.searching) { return }
			if (!this.filters.product_search_term) {
				this.productList = []
				return
			}
			this.searching = true
			this.productList = []
			let postObject = {
				search_term: this.filters.product_search_term,
				page: 1,
				ignore_availability: true,
				get_filters: false
			}
			this.apiCall({ destination: 'get_list_products', data: postObject }).then(obj => {
				this.searching = false
				this.productList = obj.list
				if (obj.pagination) {
					this.productPaging = obj.pagination
				}
			}).catch(err => {
				this.searching = false
				console.log(err)
			})
		},
		saveItem(item) {
			if (this.saving) { return }
			this.saving = true
			this.message = 'Saving product restriction...'
			this.messageStatus = 'waiting'
			this.apiCall({ destination: 'save_item_product_restriction', data: { product_id: item.product_id, exception_list_id: this.filters.exception_list_id } }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.message = 'Product restriciton saved!'
					this.messageTimeout = 1500
					this.listDetail = {}
					this.getList()
				} else {
					this.message = obj.message || 'There was an error saving the product restriction.'
				}
			}).catch(err => {
				console.log(err)
			})
		},
		backToList(updateRequired) {
			this.listDetail = {}
			this.showDetail = false
			this.saving = false
			this.searching = false
			this.confirmDelete = false
			this.saveMessage = ''
			this.searchMessage = ''
			if (updateRequired) {
				this.getList()
			}
		},
		doExport() {
			if (this.gettingExport) { return false }
			this.gettingExport = true

			//this.exportMessage = 'Generating CSV for ' + this.list.length + ' items...'

			this.saving = true
			this.message = 'Generating CSV for ' + this.list.length + ' items...'
			this.messageStatus = 'waiting'

			this.filters.product_id = ''
			this.filters.do_export = true
			this.getList()
		}
	}
}
</script>
